import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { Carousel, P, ReviewCard } from '@savebetter/components';

import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface ReviewCard extends SbBlokData {
  grade: string;
  text: string;
  name: string;
}

interface Blok extends PageSectionBlok {
  title: string;
  description: string;
  reviewCards: ReviewCard[];
}

interface ReviewProps extends PageSectionProps {
  blok: Blok;
}

interface ReviewContainerProps {
  card: ReviewCard;
}

// Note:- Container needs to get the props from Carousel that Blok doesn't pass.
const ReviewCardContainer: FunctionComponent<React.PropsWithChildren<ReviewContainerProps>> = ({
  card,
  ...restProps
}) => {
  const { grade, text, name } = card;
  return (
    <ReviewCard
      {...storyblokEditable(card)}
      rating={Number(grade)}
      review={text}
      name={name}
      tabIndex={0}
      className="focus:sb-box-shadow"
      {...restProps}
    />
  );
};

export const Review: FunctionComponent<React.PropsWithChildren<ReviewProps>> = ({ blok, sectionClassName }) => {
  const { hasBackground, hasBorder, title, description, reviewCards = [], hasPaddingBottom, hasPaddingTop } = blok;
  const slides = reviewCards.map(card => <ReviewCardContainer card={card} key={card._uid} />);

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader>{title}</PageSectionHeader>
      <P className="mb-8 text-center">{description}</P>
      <Carousel contentLabel={title} slides={slides} useDefaultSlideWrapper={false} />
    </Section>
  );
};
